/**
 * WAS DAS FENSTER SICH PRO NUTZER MERKT (Rafael, 24.10.2026: „Was ist neu und warum — das kommt jedes Mal, das muss gemerkt werden“): genau zwei kleine Werte, keine Inhalte.
 * `hinweisGesehen`: der Hinweis „Was ist neu und warum“ und der Stern „NEU“ erscheinen nicht mehr von selbst (das ⓘ ruft ihn weiter ab).
 * `wahl`: die zuletzt BEWUSST gewaehlte Ansicht; ohne Wahl gilt die Vorgabe der Nutzerart.
 * Rein (kein Fenster, kein Speicher): der Ort des Speicherns ist `useUiPreferences`, hier steht nur, was gespeichert werden darf.
 */
export type MerkAnsicht = 'raum' | 'oberthema';
export interface GuideAnsichtMerk { hinweisGesehen: boolean; wahl: MerkAnsicht | null }
export type GuideAnsichtMerkMap = Record<string, GuideAnsichtMerk>;
/** So viele Nutzer werden hoechstens gemerkt (der aelteste faellt zuerst heraus) — der Speicher waechst nicht ohne Grenze. */
export const MERK_MAX_NUTZER = 50;

/** Liest einen gespeicherten Wert streng: alles, was nicht genau die zwei Felder hat, wird verworfen (kein Raten, kein Absturz bei kaputtem Speicher). */
export function bereinigeAnsichtMerk(roh: unknown): GuideAnsichtMerkMap {
  const aus: GuideAnsichtMerkMap = {};
  if (typeof roh !== 'object' || roh === null || Array.isArray(roh)) return aus;
  for (const [nutzer, w] of Object.entries(roh as Record<string, unknown>).slice(0, MERK_MAX_NUTZER)) {
    if (!nutzer || nutzer.length > 100 || typeof w !== 'object' || w === null) continue;
    const o = w as Record<string, unknown>;
    aus[nutzer] = { hinweisGesehen: o.hinweisGesehen === true, wahl: o.wahl === 'raum' || o.wahl === 'oberthema' ? o.wahl : null };
  }
  return aus;
}

/** Setzt Teile des Merkzettels EINES Nutzers; alle anderen bleiben unberuehrt. Der Nutzer steht danach zuletzt (Verdraengung des aeltesten). */
export function merkeFuerNutzer(karte: GuideAnsichtMerkMap, nutzer: string, teil: Partial<GuideAnsichtMerk>): GuideAnsichtMerkMap {
  if (!nutzer) throw new Error('merkeFuerNutzer: Nutzerkennung fehlt');
  const alt = karte[nutzer] ?? { hinweisGesehen: false, wahl: null };
  const neu: GuideAnsichtMerk = { hinweisGesehen: teil.hinweisGesehen ?? alt.hinweisGesehen, wahl: teil.wahl === undefined ? alt.wahl : teil.wahl };
  const ohne = Object.entries(karte).filter(([k]) => k !== nutzer);
  return Object.fromEntries([...ohne.slice(Math.max(0, ohne.length - (MERK_MAX_NUTZER - 1))), [nutzer, neu]]);
}
